var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('LessonForm',{attrs:{"lessonId":_vm.lessonId},on:{"redirectToBook":_vm.redirectToBook}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }